import React, { useState, useCallback } from "react";
import { IconButton } from "components/common";
import { MessageFieldsEditModal } from "components/common/message/details";
const EditFavoriteFieldsAction = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleEditMode = useCallback(() => setIsOpen((cur) => !cur), []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, { name: "edit", title: "Edit favorite fields", onClick: toggleEditMode }), isOpen && /* @__PURE__ */ React.createElement(MessageFieldsEditModal, { toggleEditMode }));
};
export default EditFavoriteFieldsAction;
